var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.selectedLogo,{tag:"component",attrs:{"width":_setup.props.width,"height":_setup.props.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }